/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentContentListItems.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Content List Item API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Archetact ]
 *  
 *  Created:    Monday, July 04, 2022 - 01:12:19 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/04/2022  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2022 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const ContentListItems = {
  all: (contentlistid, search, month, year, order) => {
    var query = `/ContentListItems?contentlistid=${contentlistid}`
    if (search) {
      query += `&search=${search}`;
    }
    if (month) {
      query += `&month=${month}`;
    }
    if (year) {
      query += `&year=${year}`;
    }
    if (order) {
      query += `&order=${order}`;
    }
    return requests.get(query)
  },
  get: contentlistitemid => requests.get(`/ContentListItem/${contentlistitemid}`),
  create: contentlistitem => requests.post(`/ContentListItems`, contentlistitem),
  update: (contentlistitemid, contentlistitem) => requests.put(`/ContentListItem/${contentlistitemid}`, contentlistitem),
  delete: (contentlistitemid, contentlistitem) => requests.del(`/ContentListItem/${contentlistitemid}`, contentlistitem),
  getBySlug: slug => requests.get(`/ContentListItemBySlug`, slug),
};